import { render, staticRenderFns } from "./Papelera.vue?vue&type=template&id=b8e1209c&"
import script from "./Papelera.vue?vue&type=script&lang=js&"
export * from "./Papelera.vue?vue&type=script&lang=js&"
import style0 from "./Papelera.vue?vue&type=style&index=0&id=b8e1209c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports